import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import { Box, Stack, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Logout from "./Logout";
import SpecialNotificationList from "../Notification/SpecialNotificationList";
import NotificationList from "../Notification/NotificationList";
import { logoutUser } from "../../ReduxTLK/features/User/LoginSlice";
import { NavContext } from "../../App";
import { Persistor } from "../.."; // adapt if needed
import New from "../../Pages/SAV/NewSAVTicket/NewSAVTicket";
import { addTab, setLastActiveTab } from "../../ReduxTLK/features/Tabs/TabsSlice";

export default function NavBarButtons() {
  const isAutoLogin = localStorage.getItem("iframeAutoLogin") === "true";
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationListOpen, setNotificationListOpen] = React.useState(false);
  const navigate = useNavigate();
  const context = useContext(NavContext);

  // Ajout Ticket Logic — Reused from Sidebar
  function openAjoutTicket() {
    const tabId = 2;
    const existingTab = context.tabs.find((tab) => tab.id === tabId);

    if (existingTab) {
      context.setActiveTab(tabId);
      dispatch(setLastActiveTab(tabId));
      return;
    }

    dispatch(addTab({
      module: 'SAV',
      action: 'Ajout Ticket',
      identifier: tabId,
      id: tabId,
      label: 'Ajout Ticket',
    }));

    context.setTabs([...context.tabs, {
      id: tabId,
      label: 'Ajout Ticket',
      identifier: tabId,
      component: <New />,
      closeable: true,
      icon: <AddIcon />,
    }]);
    Persistor.persist();
    context.setActiveTab(tabId);
    dispatch(setLastActiveTab(tabId));
  }

  const openNotificationList = (event) => {
    setAnchorEl(event.currentTarget);
    setNotificationListOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispatch(logoutUser());
    context?.signalRService?.connection?.stop();
    navigate("/");
  };

  return (
    <>
      <Stack 
        direction="row" 
        spacing={2} 
        alignItems="center"
        sx={{
          padding: '8px 16px',
          height: '100%',
        }}
      >

        {/* Ajout Ticket Button */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            variant="contained"
            color="success"
            startIcon={<AddIcon />}
            onClick={openAjoutTicket}
            sx={{ minWidth: 0, padding: '6px 14px', fontSize: '0.95rem' }}
          >
            Ajout Ticket
          </Button>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SpecialNotificationList
            open={notificationListOpen}
            setNotificationListOpen={setNotificationListOpen}
            openNotificationList={openNotificationList}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <NotificationList
            open={notificationListOpen}
            setNotificationListOpen={setNotificationListOpen}
            openNotificationList={openNotificationList}
          />
        </Box>

        {!isAutoLogin && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Logout />
          </Box>
        )}
      </Stack>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            marginTop: '8px',
            borderRadius: '8px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <MenuItem 
          onClick={handleLogout}
          sx={{
            fontFamily: 'DM Sans',
            padding: '10px 20px',
            '&:hover': {
              backgroundColor: '#F4F7FE',
            }
          }}
        >
          Se déconnecter
        </MenuItem>
      </Menu>
    </>
  );
}